import { type Repub, type RepubConfig } from '@cx-modules/types';

import { locales } from './locales';

export const REPUBS: Readonly<Record<Repub, RepubConfig>> = {
  AU: {
    countryCode: 'AU',
    dateProperties: {
      format: {
        dateFull: 'EEEE, do MMMM',
        dateShort: 'do MMM',
        time: 'h:mm a',
        timeDateFull: 'do MMM yyyy, h:mm a',
        timeDateShort: 'do MMM, h:mm a',
        timeDayDateShort: 'EEE, do MMM, h:mm a',
      },
      locale: locales.enAU,
      timezone: 'Australia/Sydney',
      today: 'Today',
    },
    locale: 'en-AU',
    name: 'AU',
  },
  BR: {
    countryCode: 'BR',
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: 'HH:mm a',
        timeDateFull: "d 'de' MMM yyyy, HH:mm",
        timeDateShort: "d 'de' MMM, HH:mm",
        timeDayDateShort: "EEE, d 'de' MMM, HH:mm",
      },
      locale: locales.ptBR,
      timezone: 'America/Sao_Paulo',
      today: 'Hoje',
    },
    locale: 'pt-BR',
    name: 'BR',
  },
  CA: {
    countryCode: 'CA',
    dateProperties: {
      format: {
        dateFull: 'EEEE, MMMM d',
        dateShort: 'MMM d',
        time: 'h:mm a',
        timeDateFull: 'MMMM d, yyyy, h:mm a',
        timeDateShort: 'MMM d, h:mm a',
        timeDayDateShort: 'EEE, MMM d, h:mm a',
      },
      locale: locales.enCA,
      timezone: 'America/New_York',
      today: 'Today',
    },
    locale: 'en-CA',
    name: 'CA',
  },
  CO: {
    countryCode: 'CO',
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: 'h:mm a',
        timeDateFull: 'd MMM yyyy, h:mm a',
        timeDateShort: 'd MMM, h:mm a',
        timeDayDateShort: 'EEE, d MMM, h:mm a',
      },
      locale: locales.es,
      timezone: 'America/Bogota',
      today: 'Hoy',
    },
    locale: 'es-CO',
    name: 'CO',
  },
  CX: {
    countryCode: 'CX',
    dateProperties: {
      format: {
        dateFull: 'EEEE, do MMMM',
        dateShort: 'do MMM',
        time: 'h:mm a',
        timeDateFull: 'do MMM yyyy, h:mm a',
        timeDateShort: 'do MMM, h:mm a',
        timeDayDateShort: 'EEE, do MMM, h:mm a',
      },
      locale: locales.enAU,
      timezone: 'Australia/Sydney',
      today: 'Today',
    },
    locale: 'en-CX',
    name: 'CX',
  },
  DE: {
    countryCode: 'DE',
    dateProperties: {
      format: {
        dateFull: 'EEEE, d. MMMM',
        dateShort: 'd. MMM',
        time: 'HH:mm',
        timeDateFull: 'd. MMM yyyy, HH:mm',
        timeDateShort: 'd. MMM, HH:mm',
        timeDayDateShort: 'EEE, d. MMM, HH:mm',
      },
      locale: locales.de,
      timezone: 'Europe/Berlin',
      today: 'Heute',
    },
    locale: 'de-DE',
    name: 'DE',
  },
  DK: {
    countryCode: 'DK',
    dateProperties: {
      format: {
        dateFull: "EEEE 'den' d. MMMM",
        dateShort: 'd. MMM',
        time: 'HH:mm',
        timeDateFull: 'd. MMM yyyy, HH:mm',
        timeDateShort: 'd. MMM, HH:mm',
        timeDayDateShort: "EEE 'den' d. MMM, HH:mm",
      },
      locale: locales.da,
      timezone: 'Europe/Copenhagen',
      today: 'I dag',
    },
    locale: 'da-DK',
    name: 'DK',
  },
  ES: {
    countryCode: 'ES',
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: 'h:mm a',
        timeDateFull: 'd MMM yyyy, h:mm a',
        timeDateShort: 'd MMM, h:mm a',
        timeDayDateShort: 'EEE, d MMM, h:mm a',
      },
      locale: locales.es,
      timezone: 'Europe/Madrid',
      today: 'Hoy',
    },
    locale: 'es-ES',
    name: 'ES',
  },
  FR: {
    countryCode: 'FR',
    dateProperties: {
      format: {
        dateFull: 'EEEE d MMMM',
        dateShort: 'd MMM',
        time: 'HH:mm',
        timeDateFull: 'd MMM yyyy, HH:mm',
        timeDateShort: 'd MMM, HH:mm',
        timeDayDateShort: 'EEE, d MMM, HH:mm',
      },
      locale: locales.fr,
      timezone: 'Europe/Paris',
      today: "Aujourd'hui",
    },
    locale: 'fr-FR',
    name: 'FR',
  },
  GZ: {
    countryCode: 'IT',
    dateProperties: {
      format: {
        dateFull: 'EEEE, d MMMM',
        dateShort: 'd MMM',
        time: 'HH:mm',
        timeDateFull: 'd MMM yyyy, HH:mm',
        timeDateShort: 'd MMM, HH:mm',
        timeDayDateShort: 'EEE, d MMM, HH:mm',
      },
      locale: locales.it,
      timezone: 'Europe/Rome',
      today: 'Oggi',
    },
    locale: 'it-IT',
    name: 'GZ',
  },
  IN: {
    countryCode: 'IN',
    dateProperties: {
      format: {
        dateFull: 'EEEE, d MMMM',
        dateShort: 'd MMM',
        time: 'h:mm a',
        timeDateFull: 'd MMM yyyy, h:mm a',
        timeDateShort: 'd MMM, h:mm a',
        timeDayDateShort: 'EEE, d MMM, h:mm a',
      },
      locale: locales.enIN,
      timezone: 'Asia/Kolkata',
      today: 'Today',
    },
    locale: 'en-IN',
    name: 'IN',
  },
  IT: {
    countryCode: 'IT',
    dateProperties: {
      format: {
        dateFull: 'EEEE, d MMMM',
        dateShort: 'd MMM',
        time: 'HH:mm',
        timeDateFull: 'd MMM yyyy, HH:mm',
        timeDateShort: 'd MMM, HH:mm',
        timeDayDateShort: 'EEE, d MMM, HH:mm',
      },
      locale: locales.it,
      timezone: 'Europe/Rome',
      today: 'Oggi',
    },
    locale: 'it-IT',
    name: 'IT',
  },
  KE: {
    countryCode: 'KE',
    dateProperties: {
      format: {
        dateFull: 'EEEE, d MMMM',
        dateShort: 'd MMM',
        time: 'h:mm a',
        timeDateFull: 'd MMM yyyy, h:mm a',
        timeDateShort: 'd MMM, h:mm a',
        timeDayDateShort: 'EEE, d MMM, h:mm a',
      },
      locale: locales.enGB,
      timezone: 'Africa/Nairobi',
      today: 'Today',
    },
    locale: 'en-KE',
    name: 'KE',
  },
  NG: {
    countryCode: 'NG',
    dateProperties: {
      format: {
        dateFull: 'EEEE, d MMMM',
        dateShort: 'd MMM',
        time: 'h:mm a',
        timeDateFull: 'd MMM yyyy, h:mm a',
        timeDateShort: 'd MMM, h:mm a',
        timeDayDateShort: 'EEE, d MMM, h:mm a',
      },
      locale: locales.enGB,
      timezone: 'Africa/Lagos',
      today: 'Today',
    },
    locale: 'en-NG',
    name: 'NG',
  },
  NL: {
    countryCode: 'NL',
    dateProperties: {
      format: {
        dateFull: 'EEEE, d MMMM',
        dateShort: 'd MMM',
        time: 'HH:mm',
        timeDateFull: 'd MMM yyyy, HH:mm',
        timeDateShort: 'd MMM, HH:mm',
        timeDayDateShort: 'EEE, d MMM, HH:mm',
      },
      locale: locales.nl,
      timezone: 'Europe/Amsterdam',
      today: 'Vandaag',
    },
    locale: 'nl-NL',
    name: 'NL',
  },
  NZ: {
    countryCode: 'NZ',
    dateProperties: {
      format: {
        dateFull: 'EEEE, d MMMM',
        dateShort: 'd MMM',
        time: 'h:mm a',
        timeDateFull: 'd MMM yyyy, h:mm a',
        timeDateShort: 'd MMM, h:mm a',
        timeDayDateShort: 'EEE, d MMM, h:mm a',
      },
      locale: locales.enNZ,
      timezone: 'Pacific/Auckland',
      today: 'Today',
    },
    locale: 'en-NZ',
    name: 'NZ',
  },
  OC: {
    countryCode: 'GB',
    dateProperties: {
      format: {
        dateFull: 'EEEE, do MMMM',
        dateShort: 'do MMM',
        time: 'h:mm a',
        timeDateFull: 'do MMM yyyy, h:mm a',
        timeDateShort: 'do MMM, h:mm a',
        timeDayDateShort: 'EEE, do MMM, h:mm a',
      },
      locale: locales.enGB,
      timezone: 'Europe/London',
      today: 'Today',
    },
    locale: 'en-GB',
    name: 'OC',
  },
  PT: {
    countryCode: 'PT',
    dateProperties: {
      format: {
        dateFull: 'EEEE, d MMMM',
        dateShort: 'd MMM',
        time: 'HH:mm',
        timeDateFull: 'd MMM yyyy, HH:mm',
        timeDateShort: 'd MMM, HH:mm',
        timeDayDateShort: 'EEE, d MMM, HH:mm',
      },
      locale: locales.pt,
      timezone: 'Europe/Lisbon',
      today: 'Hoje',
    },
    locale: 'pt-PT',
    name: 'PT',
  },
  SE: {
    countryCode: 'SE',
    dateProperties: {
      format: {
        dateFull: 'EEEE, d MMMM',
        dateShort: 'd MMM',
        time: 'HH:mm',
        timeDateFull: 'd MMM yyyy, HH:mm',
        timeDateShort: 'd MMM, HH:mm',
        timeDayDateShort: 'EEE, d MMM, HH:mm',
      },
      locale: locales.sv,
      timezone: 'Europe/Stockholm',
      today: 'Idag',
    },
    locale: 'sv-SE',
    name: 'SE',
  },
  SM: {
    countryCode: 'SM',
    dateProperties: {
      format: {
        dateFull: 'EEEE, d MMMM',
        dateShort: 'd MMM',
        time: 'HH:mm',
        timeDateFull: 'd MMM yyyy, HH:mm',
        timeDateShort: 'd MMM, HH:mm',
        timeDayDateShort: 'EEE, d MMM, HH:mm',
      },
      locale: locales.it,
      timezone: 'Europe/San_Marino',
      today: 'Oggi',
    },
    locale: 'it-SM',
    name: 'SM',
  },
  US: {
    countryCode: 'US',
    dateProperties: {
      format: {
        dateFull: 'EEEE, MMMM d',
        dateShort: 'MMM d',
        time: 'h:mm aa zzz',
        timeDateFull: 'MMMM d, yyyy, h:mm aa zzz',
        timeDateShort: 'MM/dd h:mm aa',
        timeDayDateShort: 'EEE MMM d, h:mm aa zzz',
      },
      locale: locales.enUS,
      timezone: 'America/New_York',
      today: 'Today',
    },
    locale: 'en-US',
    name: 'US',
  },
  WS: {
    countryCode: 'GB',
    dateProperties: {
      format: {
        dateFull: 'EEEE, do MMMM',
        dateShort: 'do MMM',
        time: 'h:mm a',
        timeDateFull: 'do MMM yyyy, h:mm a',
        timeDateShort: 'do MMM, h:mm a',
        timeDayDateShort: 'EEE, do MMM, h:mm a',
      },
      locale: locales.enGB,
      timezone: 'Europe/London',
      today: 'Today',
    },
    locale: 'en-GB',
    name: 'WS',
  },
  XX: {
    countryCode: 'XX',
    dateProperties: {
      format: {
        dateFull: 'EEEE, d MMMM',
        dateShort: 'd MMM',
        time: 'h:mm a',
        timeDateFull: 'd MMM yyyy, h:mm a',
        timeDateShort: 'd MMM, h:mm a',
        timeDayDateShort: 'EEE, d MMM, h:mm a',
      },
      locale: locales.enUS, // Placeholder locale
      timezone: 'America/New_York',
      today: 'Today',
    },
    locale: 'xx-XX',
    name: 'XX',
  },
  ZA: {
    countryCode: 'ZA',
    dateProperties: {
      format: {
        dateFull: 'EEEE, d MMMM',
        dateShort: 'd MMM',
        time: 'h:mm a',
        timeDateFull: 'd MMM yyyy, h:mm a',
        timeDateShort: 'd MMM, h:mm a',
        timeDayDateShort: 'EEE, d MMM, h:mm a',
      },
      locale: locales.enZA,
      timezone: 'Africa/Johannesburg',
      today: 'Today',
    },
    locale: 'en-ZA',
    name: 'ZA',
  },
};

export const REPUBS_WITH_BOOKIE_LOGOS = [REPUBS.IT.name, REPUBS.ES.name, REPUBS.BR.name];
export const REPUBS_WITH_TRANSLATED_BET_NAMES = [REPUBS.IT.name, REPUBS.ES.name, REPUBS.BR.name];
